import { useCallback, useEffect, useState } from "react";
import api from "../lib/api";

// Contatore condiviso delle richieste "da confermare": polling ogni 30s +
// refetch al ritorno sulla tab. refreshPending() forza l'aggiornamento immediato.
export default function usePendingCount() {
  const [pendingCount, setPendingCount] = useState(0);

  const refreshPending = useCallback(() => {
    api.get("/reservations/pending-count")
      .then((r) => setPendingCount(r.data.count || 0))
      .catch(() => {});
  }, []);

  useEffect(() => {
    refreshPending();
    const iv = setInterval(refreshPending, 30000);
    const onVis = () => { if (document.visibilityState === "visible") refreshPending(); };
    document.addEventListener("visibilitychange", onVis);
    return () => { clearInterval(iv); document.removeEventListener("visibilitychange", onVis); };
  }, [refreshPending]);

  return { pendingCount, refreshPending };
}
